import { Component, Element, h, Host, Prop } from "@stencil/core";
import { UpdateMode } from "@apis/model/add-to-cart-event";

@Component({
  tag: "bcp-with-product-details",
})
export class BcpWithProductDetails {
  @Element() host: HTMLBcpWithProductDetailsElement;

  @Prop() productCode: string;

  @Prop({
    mutable: true,
    reflect: true,
  })
  quantity: number;

  @Prop({
    mutable: true,
    reflect: true,
  })
  oldQuantity: number;

  @Prop({
    mutable: true,
    reflect: true,
  })
  mode: UpdateMode;

  componentDidLoad(): void {
    const children = [...this.host.children[0].children];
    children.forEach((child) => {
      this.productCode && child.setAttribute("product-code", this.productCode);
    });
  }

  componentDidRender(): void {
    const children = [...this.host.children[0].children];
    children.forEach((child) => {
      this.quantity && child.setAttribute("quantity", this.quantity.toString());
      this.oldQuantity &&
        child.setAttribute("oldQuantity", this.oldQuantity.toString());
      this.mode && child.setAttribute("mode", this.mode.toString());
    });
  }

  render() {
    return (
      <Host>
        <div class="product-details">
          <slot></slot>
        </div>
      </Host>
    );
  }
}
